
// Vendor
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

// Internal
import { Loading, ItemListDistintaConsumi } from '@/components';
import { Utente, Distinta } from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';
import { DistintaPerModello } from '../models/DistintaPerModello';

@Component({
  components: {
    Loading,
    ItemListDistintaConsumi
  }
})
export default class ConsumiGestioneBC extends Vue {
  @Prop() private distinte!: DistintaPerModello[];

  get loading() { return store.state.loading; }

  get user() { return store.state.currentUsr; }

  get userIsAdmin() {
    return (
      this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
      undefined
    );
  }  

  created(): void {
  }

}
